/**
 * @module-isolated analytics-reuniones
 */
import { fetchMeetingsAnalytics } from '../../../services/analytics-api.js';
import { getIdToken } from '../../../services/firebase-auth.js';
import { withSessionCache } from '../../../shared/utils/session-cache.js';

function key_(f) {
  return (
    'meetings:' + [f.dateFrom || '', f.dateTo || '', f.executiveId || '', f.status || ''].join('|')
  );
}

export async function fetchMeetingsDashboard(filters) {
  const f = filters || {};
  const force = !!f.force;
  return withSessionCache(
    key_(f),
    async () => {
      const token = await getIdToken(false);
      const raw = await fetchMeetingsAnalytics(f, token);
      return {
        sourceStatus: raw.sourceStatus || (raw.success === false ? 'error' : 'ok'),
        loadedAt: raw.generatedAt || new Date().toISOString(),
        message:
          (raw._serverCache ? 'Caché servidor (hasta 30 min). ' : '') +
          (raw.message || raw.note || ''),
        kpis: raw.kpis || [],
        funnel: raw.funnel || [],
        charts: raw.charts || {},
        table: raw.table || { columns: [], rows: [] },
        alerts: raw.alerts || [],
        alertPlaceholders: raw.alertPlaceholders || [],
        catalogs: raw.catalogs || { executives: [], projects: [], channels: [], statuses: [] }
      };
    },
    { force }
  );
}
